// deriveImageryGroups.js

/**
 * Derive LayerPanel-compatible groups from imagery registry
 *
 * Imagery
 *  └── Basin
 *      └── Region
 *          └── Time layers
 */
export function deriveImageryGroups({ layers = [], userRole }) {
  const byBasin = {};

  if (!Array.isArray(layers) || layers.length === 0) {
    return [];
  }

  layers.forEach((layer) => {
    if (!layer) return;
    if (layer.roles && !layer.roles.includes(userRole)) return;

    const {
      id,
      label,
      basin,
      region,
      defaultOn,
      opacity,
      minzoom,
      maxzoom,
    } = layer;

    if (!basin || !region) return;

    byBasin[basin] ??= {};
    byBasin[basin][region] ??= [];

    byBasin[basin][region].push({
      id,
      label: label ?? id,
      defaultOn: !!defaultOn,
      opacity: opacity ?? 1.0,
      minzoom,
      maxzoom,
    });
  });

  return Object.entries(byBasin).map(([basin, regions]) => ({
    id: `imagery.${basin}`,
    title: basinLabel(basin),
    roles: ["viewer", "analyst", "admin"],
    groups: Object.entries(regions).map(([region, layers]) => ({
      id: `imagery.${basin}.${region}`,
      title: regionLabel(region),
      layers: layers.sort((a, b) => b.id.localeCompare(a.id)),
    })),
  }));
}

function basinLabel(basin) {
  return {
    permian: "Permian Basin",
    williston: "Williston Basin",
    eagle_ford: "Eagle Ford",
    anadarko: "Anadarko Basin",
  }[normalizeKey(basin)] ?? basin;
}

function regionLabel(region) {
  return {
    delaware: "Delaware",
    eastern_shelf: "Eastern Shelf",
    midland: "Midland",
    central_basin_platform: "Central Basin Platform",
  }[normalizeKey(region)] ?? region.replaceAll("_", " ");
}

function normalizeKey(v) {
  return v
    .toLowerCase()
    .replaceAll("-", "_")
    .replaceAll(" ", "_");
}